import React, { useEffect, useState } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import {
  addBidderForEvent,
  amountFormatter,
  getBidderTypeLabel,
  getBidderByUserUuidAndEventUuid,
  getBidderForEvent,
  normalizeBidderTypeForPanValidation,
} from "services";
import Dot from "../../../../icons/Dot";
import MapPin from "../../../../icons/MapPin";
import { Button } from "../../../../shadcn/components/ui/button";
import PDPropertyDataSection from "../../../web/propertyDetail/PDPropertyDataSection";
import { DateTime } from "luxon";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import OnboardingFormWrapper from "../onboarding/OnboardingFormWrapper";
import AnimatedDropdown from "../../../../shadcn/components/custom/dropdown/CustomAnimatedDropdown";
import JointBidderCountModel from "./JointBidderCountModel";
import OfflineAuctionParticipationModal from "./OfflineAuctionParticipationModal";

interface PropertyDetailsModelProps {
  open: boolean;
  setOpen: any;
  selected: any;
  type?: "upcoming" | "others";
}

export default function PropertyDetailsModel({
  open,
  setOpen,
  selected,
  type = "others",
}: PropertyDetailsModelProps) {
  const router = useRouter();
  const [bidder, setBidder] = useState<any>(null);
  const [openOnboarding, setOpenOnboarding] = useState(false);
  const [openJBCountModel, setOpenJBCountModel] = useState(false);
  const [openOfflineParticipationInfo, setOpenOfflineParticipationInfo] =
    useState(false);
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  useEffect(() => {
    (async () => {
      if (selected?.data?.uuid && user?.uuid) {
        const res: any = await getBidderByUserUuidAndEventUuid(
          user.uuid,
          selected?.data?.uuid,
          "",
        );
        setBidder(res[0]);
      }
    })();
  }, [selected, open, setOpen, user]);

  const handleSubmitCount = async (data: any) => {
    router
      .replace(
        `/bidders?id=${selected.listing_id}&bidder_type=joint&bidders_count=${data.bidder_count}`,
      )
      .then(() => setOpenJBCountModel(false));
    return;
  };

  const handleBidderVerification = async (
    selected: any,
    participationType: any = "solo",
  ) => {
    //check
    const email = user?.attributes?.find((a: any) => a.type === "email")?.value;
    const mobile = user?.attributes?.find(
      (a: any) => a.type === "mobile_number",
    )?.value;
    const hasEmail = Boolean(email);
    const hasMobile = Boolean(mobile);
    if (!hasEmail || !hasMobile || !onboardingData?.mobile) {
      setOpenOnboarding(true);
      return;
    }
    // create bidder for the event first and then redirect
    try {
      const bidders: any = await getBidderForEvent(
        { per_page: 999, page: 1 },
        selected?.data?.uuid,
      );
      console.log("bidders: ", bidders);
      const allBiddersForEvent = bidders.data;
      const foundBidder = allBiddersForEvent.find(
        (item: any) => item.user_uuid === user.uuid,
      );
      if (!foundBidder && participationType !== "solo") {
        setOpenJBCountModel(true);
        return;
      }

      if (!foundBidder) {
        const normalizedOnboardingType = normalizeBidderTypeForPanValidation(
          onboardingData?.type,
        );
        let payload: any = {
          email: onboardingData.email,
          mobile_number: onboardingData?.mobile,
          name: onboardingData.name,
        };
        payload["event_uuid"] = selected?.data?.uuid;
        payload["status"] = "pending";
        payload["created_by"] = "user";
        payload["meta"] = {
          // bid_application_flow_mode: "online",
          bank_name:
            selected?.data?.meta?.bank_name ||
            selected?.data?.property_dump?.bank?.name,
          approver_email:
            selected?.data?.meta?.approver &&
            selected?.data?.meta?.approver.length > 0
              ? selected?.data?.meta?.approver[0]?.email
              : "",
          borrower_name: selected?.data?.borrower_name,
          approver_name:
            selected?.data?.meta?.approver &&
            selected?.data?.meta?.approver.length > 0
              ? selected?.data?.meta?.approver[0]?.name
                ? selected?.data?.meta?.approver[0]?.name
                : selected?.data?.meta?.approver[0]?.email
              : "",
          branch_uuid: selected?.data?.branch_uuid,
          branch_name: selected?.data?.branch?.name,
          event_name: selected?.data?.event_name,
          dashboard_url: `${process.env.NEXT_PUBLIC_BD_URL}auction-events`,
          event_id: selected.listing_id,
          auction_start_datetime: DateTime.fromISO(selected?.start_date_time)
            .setZone("Asia/Kolkata")
            .toFormat("dd MMMM yyyy hh:mm a"),
          emd_last_datetime: DateTime.fromISO(selected?.emd_last_date)
            .setZone("Asia/Kolkata")
            .toFormat("dd MMMM yyyy hh:mm a"),
          name: onboardingData.name,
          pan: onboardingData.pan,
          emd_amount: selected?.data?.property_dump?.emd_amount,
          bidding_type: selected?.data?.bidding_type,
          reserve_price: selected?.data?.reserve_price,
          enable_offline_payment_validation:
            process.env.NEXT_PUBLIC_ENABLE_ONLINE_DD_VALIDATION_FLOW === "true"
              ? selected?.data?.payment_validation_enabled || false
              : false,
          user_details: {
            user_type: normalizedOnboardingType
              ? {
                  label:
                    getBidderTypeLabel(normalizedOnboardingType) ||
                    normalizedOnboardingType,
                  value: normalizedOnboardingType,
                }
              : { label: "Individual", value: "individual" },
            address: null,
            aadhar_number: null,
            mobile_number: onboardingData?.mobile,
          },
        };
        if (
          onboardingData?.type !== "individual" &&
          process.env.NEXT_PUBLIC_ENABLE_OFFLINE_NI_KYC !== "true"
        ) {
          payload.meta.bid_application_flow_mode = "online";
        } else if (
          onboardingData?.type === "individual" &&
          process.env.NEXT_PUBLIC_ENABLE_OFFLINE_INDIVIDUALS_KYC !== "true"
        ) {
          payload.meta.bid_application_flow_mode = "online";
        }
        console.log("payload===>>>", payload);

        const res: any = await addBidderForEvent(payload);
        console.log("res::::>", res);
        if (res && res.uuid) {
          router.push(`/kyc/${res.uuid}`);
        }
      } else {
        router.push(`/kyc/${foundBidder.uuid}`);
      }
    } catch (error: any) {
      console.log("error", error);
    }
  };

  const emdLastDate = DateTime.fromISO(selected?.emd_last_date)?.setZone(
    "Asia/Kolkata",
  );
  const now = DateTime?.now()?.setZone("Asia/Kolkata");
  const isOnlineKycEnabled = selected?.online_kyc_enabled || false;

  const dropdownOptions = [
    { label: "Individual Participation", value: "solo" },
    { label: "Joint Participation", value: "joint" },
  ];

  const isJointEnabled =
    process.env.NEXT_PUBLIC_ENABLE_ONLINE_JOINT_BIDDER_PARTICIPATION_FLOW ===
      "true" || false;

  return (
    <CustomModalLayout
      open={open}
      onClose={() => setOpen(false)}
      childrenClassName="pb-6 px-4 lg:px-8 mid:px-14 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] w-full mx-4 sm:mx-14 mid:mx-24 xl:mx-32 overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="">
        <div className="mt-4 flex flex-col lg:flex-row gap-4 lg:gap-0 w-full lg:justify-between font-sans">
          {/* Price and ID Section */}
          <div className="lg:flex">
            <div className="flex justify-between items-center lg:items-start lg:border-r lg:pr-5 lg:gap-4">
              {/* Reserve Price or Contact Info */}
              <div className="flex flex-col gap-2 lg:gap-0">
                {selected?.property_date_type !== "undated" ? (
                  <>
                    <div className="text-lg mobile:text-2xl font-bold text-brand-textBlack">
                      ₹ {amountFormatter(selected?.reserve_price)}
                    </div>
                    <div className="uppercase font-semibold text-xs lg:text-sm text-brand-headingBlue lg:mt-2">
                      Reserve Price
                    </div>
                  </>
                ) : (
                  <div className="uppercase font-semibold text-base lg:text-lg text-brand-textBlack lg:mt-1">
                    Contact us
                  </div>
                )}
              </div>

              {/* ID Section */}
              <div className="py-1 px-3 border rounded-full border-brand-textLightGrey flex items-center lg:mt-1">
                <Dot />
                <span className="text-[8px] mobile:text-[10px] lg:text-sx pl-2 font-normal uppercase tracking-widest">
                  ID {selected?.listing_id}
                </span>
              </div>
            </div>

            {/* Asset Details */}
            <div className="mt-4 lg:mt-0 lg:pl-5 lg:max-w-[400px]">
              <div className="capitalize text-sm lg:text-lg text-brand-textLightGrey">
                {`${selected?.asset?.name} / ${selected?.sub_asset_type?.name}`}
              </div>
              <div className="flex pt-1 items-center">
                <MapPin />
                <span className="px-1 text-xs lg:text-sm text-brand-textGrey capitalize">
                  {`${selected?.city?.name}, ${selected?.state?.name}`}
                </span>
              </div>
            </div>
          </div>

          {/* Participate Button */}
          <div className="flex items-center">
            {/* {process.env.NEXT_PUBLIC_ENABLE_FEATURE === "true" && ( */}
            <>
              {bidder && bidder?.status === "verified" ? (
                <div className="text-lg text-center font-sans font-bold text-green-500">
                  KYC Verified
                </div>
              ) : (
                <div>
                  {onboardingData?.status !== "active" ? (
                    <div className="w-full rounded-md flex flex-col justify-between items-start lg:items-center">
                      <p className="text-[10px] text-brand-textBlack font-semibold">
                        Complete your onboarding to participate in an auction
                      </p>
                      <Button
                        disabled={openOnboarding}
                        className="bg-brand-orange text-white hover:bg-brand-orange transition px-6 py-2 text-sm rounded h-8"
                        onClick={() => setOpenOnboarding(true)}
                      >
                        Complete Now!
                      </Button>
                    </div>
                  ) : isOnlineKycEnabled ? (
                    <div>
                      {onboardingData?.type?.toLowerCase() === "individual" ? (
                        <div>
                          {isJointEnabled ? (
                            <AnimatedDropdown
                              options={dropdownOptions}
                              onOptionClick={async (data: any) => {
                                await handleBidderVerification(
                                  selected,
                                  data.value,
                                );
                              }}
                              triggerText="Participate"
                              triggerClassName="w-full max-w-[500px] px-24 md:px-24 lg:px-16"
                              disabled={
                                type === "upcoming" || now > emdLastDate
                              }
                            />
                          ) : (
                            <Button
                              disabled={
                                type === "upcoming" || now > emdLastDate
                              }
                              className="w-full lg:px-24"
                              onClick={() => handleBidderVerification(selected)}
                            >
                              Participate
                            </Button>
                          )}

                          {now > emdLastDate && (
                            <p className="text-[8px] text-center">
                              EMD date has passed. Contact us.
                            </p>
                          )}
                        </div>
                      ) : (
                        <div>
                          <Button
                            disabled={type === "upcoming" || now > emdLastDate}
                            className="w-full lg:px-24"
                            onClick={() =>
                              handleBidderVerification(selected, "solo")
                            }
                          >
                            Participate
                          </Button>
                          {now > emdLastDate && (
                            <p className="text-[8px] text-center">
                              EMD date has passed. Contact us.
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <Button
                        disabled={type === "upcoming"}
                        className="w-full lg:px-16"
                        onClick={() => setOpenOfflineParticipationInfo(true)}
                      >
                        Participation Steps
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </>
            {/* )} */}
          </div>
        </div>
        <div className="-mt-4">
          <PDPropertyDataSection propertyData={selected} />
        </div>
        {openOnboarding && (
          <OnboardingFormWrapper
            open={openOnboarding}
            setOpen={setOpenOnboarding}
          />
        )}
        {openJBCountModel && (
          <JointBidderCountModel
            open={openJBCountModel}
            setOpen={setOpenJBCountModel}
            handleSubmit={handleSubmitCount}
          />
        )}
        <OfflineAuctionParticipationModal
          open={openOfflineParticipationInfo}
          setOpen={setOpenOfflineParticipationInfo}
          selected={selected}
        />
      </div>
    </CustomModalLayout>
  );
}
